import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Icon} from '../UI/Icon';
import {classNamesPrefixed} from '../../../helpers/CoreHelpers';
import BtnSecondary from "../UI/BtnSecondary";

class Button extends Component {
    render() {
        let {
            title,
            buttonStyle,
            buttonType,
            icon,
            disabled,
            onClick,
            value,
            help,
            className,
            fakeButton,
            type
        } = this.props;

        if (!buttonStyle) {
            buttonStyle = '';
        }

        if (!buttonType) {
            buttonType = 'button';
        }

        if (!title) {
            title = '';
        }

        if (!value) {
            value = '';
        }

        if (!help) {
            help = '';
        }


        let classNames = [];
        let classNamesObj = {};
        if (className) {
            classNames = className.split(" ");
        }
        classNames.unshift("btn");
        if (buttonStyle) {
            classNames.unshift(buttonStyle);
        }
        for (let x in classNames) {
            classNamesObj[classNames[x]] = true;
        }
        if (fakeButton){
            return (
                <span
                    title={help}
                    className={classNamesPrefixed(classNamesObj)}
                >
                    {icon && icon.length > 0 &&
                        <Icon value={value} name={icon} type={type ? type : 'fa'} />
                    }
                    {title}
                </span>
            );
        }

        return (
            <BtnSecondary
                disabled={disabled}
                buttonType={buttonType}
                onClick={onClick}
                value={value}
                title={help}
                className={classNamesPrefixed(classNamesObj)}
            >
                {icon && icon.length > 0 &&
                <Icon value={value} name={icon} type={type ? type : 'fa'} />
                }
                {title}
            </BtnSecondary>
        );
    };
}

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Button)


// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/Button.js